import React from 'react';

import {Button} from '@mantine/core';
import {Box} from 'src/design/atoms/Box';
import {Subtitle} from 'src/design/atoms/Typography';

export interface TrackerActiveSessionTimeoutProps {
  onContinue: () => void;
}
export const TrackerActiveSessionTimeout: React.FC<
  TrackerActiveSessionTimeoutProps
> = ({onContinue}) => {
  const title = 'Time limit exceeded';
  const body =
    'Unfortunately, your time limit for this content has been reached and your session has been ended. To continue the training, you must begin the training again and complete all content within the time limit shown in the the training.';

  return (
    <Box>
      <Subtitle text={title} />
      <p>{body}</p>
      <Button size="sm" onClick={onContinue}>
        Continue
      </Button>
    </Box>
  );
};
